import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {OfferService} from '../../../services/offer/offer.service';
import {PrivateNote} from '../../../model/offer/private-note';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../../store/proposal/reducers/proposal.reducer';
import {PrivateNoteLocation} from '../../../enum/private-note-location';
import {UserAppState} from '../../../store/user/reducers/user.reducer';
import {selectUserId} from '../../../store/user/selectors/user.selectors';
import {ProposalDetailPageActions} from '../../../store/proposal/actions/proposal.actions';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-private-notes-dialog',
    templateUrl: './private-notes-dialog.component.html',
    styleUrls: ['./private-notes-dialog.component.scss', '../../../../styles/create-something.scss', '../../../../styles/form-input.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrivateNotesDialogComponent implements OnInit{

  title: string = '';
  placeholder: string = '';
  optionSave: string = '';
  optionCancel: string = '';
  note: string = '';
  location: string = '';
  id: string = '';
  offerId: string = '';
  proposalId: string = '';

  activeUserId: string;

  constructor(public dialogRef: MatDialogRef<PrivateNotesDialogComponent>,
              private readonly offerService: OfferService,
              private readonly proposalStore: Store<ProposalAppState>,
              private readonly userStore: Store<UserAppState>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.placeholder = data.placeholder;
    this.optionSave = data.optionSave;
    this.optionCancel = data.optionCancel;
    this.location = data.location;
    this.note = data.note;
    this.id = data.id;
    this.offerId = data.offerId;
    this.proposalId = data.proposalId;
  }

  ngOnInit(): void {
    this.userStore.select(selectUserId).subscribe(userId => this.activeUserId = userId);
  }

  savePrivateNote() {
    let privateNote = new PrivateNote();
    privateNote.id = this.id;
    this.userStore.select(selectUserId).subscribe(userId => privateNote.userId = userId);
    privateNote.note = this.note;
    privateNote.location = this.convertStringToEnumLocation(this.location);
    privateNote.offerId = this.offerId;
    privateNote.proposalId = this.proposalId;
    this.offerService.savePrivateNote(privateNote)?.subscribe(() => {
      this.proposalStore.dispatch(ProposalDetailPageActions.loadPrivateNotes({userId: this.activeUserId, proposalId: this.proposalId}));
    });
  }

  convertStringToEnumLocation(strLocation: string): PrivateNoteLocation {
    switch (strLocation) {
      case 'PROPOSAL_DETAIL':
        return PrivateNoteLocation.PROPOSAL_DETAIL;
      case 'OFFER_DETAIL':
        return PrivateNoteLocation.OFFER_DETAIL;
      case 'OFFER_OVERVIEW':
        return PrivateNoteLocation.OFFER_OVERVIEW;
      case 'SLIP':
        return PrivateNoteLocation.SLIP;
      default:
        return null;
    }
  }
}
